module.exports = __webpack_public_path__ + "img/rules.bb028c0d.jpg";